import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import UserLayout from "../../layouts/UserLayout/UserLayout";
import ProfileUser from "../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import UsersAdmin from "../../pages/Admin/UsersAdmin/UsersAdmin";
import UserAdminContext from "../../context/AdminContext/UserAdminContext/UserAdminContext";
import BulkSMSsAdmin from "../../pages/Admin/BulkSMSsAdmin/BulkSMSsAdmin";
import BulkSMSAdminContext from "../../context/AdminContext/BulkSMSAdminContext/BulkSMSAdminContext";
import OrderUserContext from "../../context/UserContext/OrderUserContext/OrderUserContext";
import OrdersUser from "../../pages/User/OrdersUser/OrdersUser";
import OrdersAdmin from "../../pages/Admin/OrdersAdmin/OrdersAdmin";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const AdminContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[0])
    return <Navigate to="/" replace />;

  return (
    <UserLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <UserAdminContext>
              <UsersAdmin />
            </UserAdminContext>
          }
        />

        {/* Users */}
        <Route
          path="/users"
          element={
            <UserAdminContext>
              <UsersAdmin />
            </UserAdminContext>
          }
        />

        {/* Profile */}
        {["/profile", "/profile/changed-password", "/profile/settings"].map(
          (key) => (
            <Route
              key={key}
              path={key}
              element={
                <ProfileUserContext>
                  <ProfileUser />
                </ProfileUserContext>
              }
            />
          ),
        )}

        {/* Orders */}
        {[
          "/orders",
          "/orders/:customer/customer",
          "/orders/:courier/courier",
        ].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <OrderUserContext>
                <OrdersUser />
              </OrderUserContext>
            }
          />
        ))}

        {/* Bulk SMS */}
        <Route
          path="/bulk-sms"
          element={
            <BulkSMSAdminContext>
              <BulkSMSsAdmin />
            </BulkSMSAdminContext>
          }
        />

        <Route path="/admin/orders" element={<OrdersAdmin />} />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </UserLayout>
  );
};

export default AdminContainer;
